var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /~/vue-loader/lib/template-compiler?{"id":"data-v-d8af1ccc","hasScoped":true,"buble":{"transforms":{}}}!/~/vue-loader/lib/selector.js?type=template&index=0!./assets/js/vue/components/StoreInit.vue
// module id = 421
// module chunks = 0